import { useCachedResource } from "common-fe";
import { useScoreApi, unwrap } from "../api/scoreApi";
import { classes } from "../local/db";

// Classes for a show — used at setup time to derive the list of rings on
// offer (score-api has no dedicated ring-listing route; `class.ring` is FVD
// free text, so distinct values off the class list is the only source), AND
// by the Order of Go to label each class header (className/classNumber).
//
// #692 — `nonce` is the same entity-refresh beat useRidesForRing/
// useBreaksForRing take: this hook used to have NO revalidation beat at all,
// so a class renamed/renumbered (or newly added) mid-show would sit stale in
// the header until a manual reload — exactly the "stale cache masks a
// change" bug the card called out. Bump nonce to force a revalidate.
// Cache-first like useShows; a null showId is a no-op (nothing picked yet).
export function useClassesForShow(showId, online, nonce = 0) {
  const api = useScoreApi();
  return useCachedResource(
    async () => {
      if (!showId) return undefined;
      const cached = await classes.byShow(showId);
      return cached.length ? cached : undefined;
    },
    async () => {
      if (!showId) return [];
      const list = unwrap(await api.classes.listClasses(showId));
      await classes.putAll(list);
      return list;
    },
    [api, showId, nonce],
    online,
  );
}
